<table class="sticky-header" *ngIf="isLoaded" border="0" cellspacing="0" cellpadding="1">
  <thead>
    <tr>
      <td class="key-col">&nbsp;</td>
      <td class="val-col"
          *ngFor="let machine of machineCapabilities.machineNames">{{machine}}</td>
    </tr>
  </thead>
</table>
<table *ngIf="isLoaded" border="0" cellspacing="0" cellpadding="1">
  <tbody>
    <tr *ngFor="let cap of machineCapabilities.capabilities">
      <td class="key-col" title="{{cap.capabilityName}}">
        <mat-icon *ngIf="cap.capabilityType==='U'" class="clickable-icon user-capability">person</mat-icon>
        <mat-icon *ngIf="cap.capabilityType==='S'" class="clickable-icon system-capability">computer</mat-icon>
        <mat-icon *ngIf="cap.capabilityType==='Q'" class="clickable-icon queried-capability">hearing</mat-icon>
        <a href="" class="clickable" (click)="showCapabilityDetails(cap, $event)">{{cap.capabilityName}}</a>
      </td>
      <td class="val-col" title="{{machineCap.value}}" *ngFor="let machineCap of cap.capabilityPerMachine">{{machineCap.value}}</td>
    </tr>
  </tbody>
</table>
